<main>
    <div id="boxWithMargin">
        <ng-content> </ng-content>
    </div>
</main>
<app-sidebar></app-sidebar>
